shadow$provide[7] = function(global,require,module,exports) {
module.exports=(ReactDOM);
};